//import moment from "moment";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function handleError(error) {
  if (error) {
    if (Array.isArray(error) && error.length > 0) {
      let errorStr = "";
      error.forEach((e) => {
        errorStr += e + "\n";
      });
     toast.error(errorStr);
    }
    if (typeof error === "string") toast.error(error);
  }
}
function handleSuccess(infotext) {
  if (infotext) {
    if (Array.isArray(infotext) && infotext.length > 0) {
      let infoStr = "";
      infotext.forEach((e) => {
        infoStr += e + "\n";
      });
     toast.success(infoStr);
    }
    if (typeof infotext === "string") toast.success(infotext);
  }
}

function downloadFile(data, filename, type) {
  const file = type ? new Blob([data], { type: type }) : new Blob([data]);

  if (window.navigator.msSaveOrOpenBlob)
    // IE10+
    window.navigator.msSaveOrOpenBlob(file, filename);
  else {
    let a = document.createElement("a"),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 0);
  }
}



const loadImage = (src, name) => {
  if (src !== "") {
    let bstr = window.atob(src);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    let file = new File([u8arr], name + ".jpg", {
      type: "image/jpeg",
    });

    file.uid = "uniquekey" + file.name;

    return [
      {
        lastModified: file.lastModified,
        lastModifiedDate: file.lastModifiedDate,
        name: file.name,
        originFileObj: file,
        size: file.size,
        status: "done",
        type: "image/jpeg",
        uid: "uniquekey" + file.name,
      },
    ];
  }
  return [];
};
function isValidEmail(email){
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
    return false;
  }
  return true;
}
const Helpers = {
  handleError,
  handleSuccess,
  downloadFile,
  loadImage,
  isValidEmail,
};

export default Helpers;
